import { BrowserRouter, Route, Routes } from "react-router-dom"
import Footer from "./components/Footer"
import IframeHeightSender from "./components/IframeHeightSender"
import Contact from "./nav/Contact"
import Error from "./nav/Error"
import FAQ from "./nav/FAQ"
import Home from "./nav/Home"
import Imprint from "./nav/Imprint"
import Privacy from "./nav/Privacy"

import Terms from "./nav/Terms"
import Store from "./store/store"
import PromoSoon from "./nav/PromoSoon"
import PromoOver from "./nav/PromoOver"
import Thankyou from "./nav/Thankyou"

declare global {
	interface Window {
		Cookiebot: any
	}
}
const App = () => {
	return (
		<BrowserRouter basename={`${process.env.PUBLIC_URL}`}>
			<div>
				{process.env.NODE_ENV === "development" && window.location.host === "localhost:3000" && (
					<div className="fixed top-5 left-1/2 -translate-x-1/2 z-50 bg-greenDark text-white border border-white rounded-full p-3">
						DEV: Switch to:{" "}
						<a href="http://localhost" className="underline">
							http://localhost
						</a>
					</div>
				)}
				<Store>
					<IframeHeightSender />
					<main className="mx-auto  w-full">
						<Routes>
							<Route path="/" element={<Home />} />
							<Route path="/danke" element={<Thankyou />} />
							<Route path="/promoover" element={<PromoOver />} />
							<Route path="/promosoon" element={<PromoSoon />} />
							<Route path="/faq" element={<FAQ />} />
							<Route path="/teilnahmebedingungen" element={<Terms />} />
							<Route path="/impressum" element={<Imprint />} />
							<Route path="/kontakt" element={<Contact />} />
							<Route path="/:err" element={<Error />} />
						</Routes>
					</main>
				</Store>
			</div>
		</BrowserRouter>
	)
}

export default App
